export function cycleRestrict(value: number, min: number, max: number): number {
  if (value === Number.POSITIVE_INFINITY) {
    return max;
  }

  if (value === Number.NEGATIVE_INFINITY) {
    return min;
  }

  return value - Math.floor((value - min) / (max - min)) * (max - min);
}
